module.exports = __webpack_public_path__ + "static/media/website.07e62e37.jpg";